// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"911c1520","455":"4b31192f","625":"ed4f869f"}[chunkId] + ".chunk.js";
};